import type {
  ApplicationAgentContractResponse,
  ApplicationContractResponse,
  ApplicationDocumentResponse,
  ApplicationExchangeRateResponse,
  ApplicationFeeResponse,
  ApplicationParticipantsResponse,
  ApplicationResponse,
  ExchangeRate2Response,
} from '@acme/api';
import { combine, createEvent, createStore, sample } from 'effector';
import {
  loadAgentContractFx,
  loadApplicationDocumentsFx,
  loadApplicationFx,
  loadApplicationLiquidityProvidersFx,
  loadContractFx,
  loadFeesFx,
  loadLiquidityProvidersFx,
  loadParticipantsFx,
} from './effects';

export const applicationOpened = createEvent<{ id: string }>();
export const applicationReset = createEvent();
export const liquidityProvidersLoadRequested = createEvent<{ id: string }>();

export const $application = createStore<ApplicationResponse | null>(null)
  .on(applicationReset, () => null)
  .on(loadApplicationFx.doneData, (_, data) => data);

export const $contract = createStore<ApplicationContractResponse | null>(null)
  .on(applicationReset, () => null)
  .on(loadContractFx.doneData, (_, data) => data);

export const $fee = createStore<ApplicationFeeResponse | null>(null)
  .on(applicationReset, () => null)
  .on(loadFeesFx.doneData, (_, data) => data);

export const $agentContract =
  createStore<ApplicationAgentContractResponse | null>(null)
    .on(applicationReset, () => null)
    .on(loadAgentContractFx.doneData, (_, data) => data);

export const $participants =
  createStore<ApplicationParticipantsResponse | null>(null)
    .on(applicationReset, () => null)
    .on(loadParticipantsFx.doneData, (_, data) => data);

export const $applicationLiquidityProviders = createStore<
  ApplicationExchangeRateResponse[]
>([])
  .on(applicationReset, () => [])
  .on(loadApplicationLiquidityProvidersFx.doneData, (_, data) => data);

export const $documents = createStore<ApplicationDocumentResponse[]>([])
  .on(applicationReset, () => [])
  .on(loadApplicationDocumentsFx.doneData, (_, data) => data);

export const $liquidityProviders = createStore<ExchangeRate2Response[]>([])
  .on(applicationReset, () => [])
  .on(loadLiquidityProvidersFx.doneData, (_, data) => data);

export const $isLoading = combine(
  loadApplicationFx.pending,
  loadContractFx.pending,
  loadAgentContractFx.pending,
  loadParticipantsFx.pending,
  loadApplicationLiquidityProvidersFx.pending,
  loadApplicationDocumentsFx.pending,
  loadLiquidityProvidersFx.pending,
  (a, b, c, d, e, f, g) => a || b || c || d || e || f || g
);

sample({
  clock: applicationOpened,
  target: [
    loadApplicationFx,
    loadContractFx,
    loadFeesFx,
    loadAgentContractFx,
    loadParticipantsFx,
    loadApplicationLiquidityProvidersFx,
    loadApplicationDocumentsFx,
  ],
});

sample({
  clock: liquidityProvidersLoadRequested,
  target: loadLiquidityProvidersFx,
});
